/**
 * Подменю текущего раздела для шапки R3: в каком разделе меню мы
 * сейчас и какие у него пункты. Чистая функция — тестируется отдельно.
 */
export interface NavTile {
  key: string;
  links: { key: string; text: string }[];
}

const pathOf = (key: string) => key.split('?')[0];

/** Раздел, в котором открыт path: пункт с самым длинным совпадением. */
export function sectionFor(tiles: NavTile[], path: string): { tile: NavTile; active: string } | null {
  let best: { tile: NavTile; active: string; len: number } | null = null;
  for (const tile of tiles) {
    if (tile.links.length < 2) continue;
    for (const l of tile.links) {
      const p = pathOf(l.key);
      if (!p.startsWith('/')) continue;
      const hit = path === p || path.startsWith(p.endsWith('/') ? p : `${p}/`);
      if (hit && (!best || p.length > best.len)) best = { tile, active: l.key, len: p.length };
    }
  }
  return best ? { tile: best.tile, active: best.active } : null;
}
